import React from 'react';
import mixpanel from 'mixpanel-browser';
import NavBar from '../NavBar';
import { Footer } from '../Footer/Footer';

import { PrivacyPolicyStateLaws } from '../../constants/PrivacyPolicy';

import './PrivacyPolicy.css';

export const PrivacyPolicy = () => {
  return (
    <>
      <NavBar currentPath="privacy_policy" />
      <div className="privacy-policy-container">
        <div className="privacyPolicy">
          <h1 className="privacy-policy-header"> Privacy Policy </h1>
          <p> Effective Date: June 3rd, 2026 </p>
          <p>
            At CashClever ("we," "us," or "our"), we are committed to protecting your privacy and
            ensuring that your personal information is handled responsibly. This Privacy Policy
            explains how we collect, use, and safeguard your personal information when you use our
            website, mobile app, or other services ("the Platform"). By using the Platform, you
            consent to the collection and use of your personal information as outlined in this
            policy.
          </p>

          <ol className="ol">
            <li className="privacy-list-item">
              <h3>1. Privacy </h3>
              <div>
                Your privacy is important to us, and we are committed to protecting the information
                you share with us. This Privacy Policy explains the types of information we collect,
                how we use it, and how we protect it. We do not sell, rent, or trade your personal
                information to third parties without your consent, except as described in this
                policy. Users who would like to have their data removed are able to request it
                directly by emailing info@cashclever.net with the email address associated with
                their account.
              </div>
            </li>
            <li className="privacy-list-item">
              <h3> 2. Collection and Use of Your Personal Information</h3>

              <div className="collection-user-personal-info">
                We collect personal information that you provide when you interact with the
                Platform, such as when you register for an account, submit a loan application, or
                contact our customer service. This information may include:
                <br></br>
                Personal Identification Information: Name, address, phone number, email address,
                date of birth, and other information you provide. Financial Information: Income,
                employment details, credit history, loan preferences, and other financial data
                necessary for loan evaluation and approval.
                <br></br>
                Device and Usage Information: Information about the devices you use to access the
                Platform, including your IP address, browser type, operating system, and browsing
                behavior.
                <br></br>
                We use your personal information for the following purposes:
              </div>

              <ul className="ul">
                <li className="privacy-list-item">
                  To provide and manage the services you request, such as loan matching and account
                  management.
                </li>
                <li className="privacy-list-item">
                  To communicate with you about your loan applications, offers, and account updates.
                </li>
                <li className="privacy-list-item">
                  {' '}
                  To improve the Platform and tailor our services to better meet your needs.
                </li>
                <li className="privacy-list-item">
                  To comply with legal and regulatory requirements.
                </li>
              </ul>
            </li>
            <li className="privacy-list-item">
              <h3>3. Cookies </h3>
              <div>
                We use cookies and similar technologies to enhance your experience when using the
                Platform. Cookies are small data files stored on your device that help us remember
                your preferences, improve site functionality, and analyze how you use the Platform.
                Some cookies may be placed by third-party services we use to track user behavior and
                improve our services.<br></br>
                You can control cookies through your browser settings. Most browsers allow you to
                block or delete cookies; however, doing so may affect certain features of the
                Platform.
              </div>
            </li>
            <li className="privacy-list-item">
              <h3>4. Target Advertising </h3>
              <div>
                We may use your information to deliver personalized ads based on your interests and
                browsing behavior, both on and off the Platform. This type of advertising, often
                referred to as 'targeted' or 'behavioral' advertising, helps us present more
                relevant offers to you. <br></br>
                Third-party advertisers and ad networks may also use cookies and web beacons to
                collect information about your online activities in order to provide targeted ads.
                You can opt out of targeted advertising by using the tools provided by third-party
                services, such as the Digital Advertising Alliance or Network Advertising
                Initiative.
              </div>
            </li>
            <li className="privacy-list-item">
              <h3>5. Other Service Providers </h3>
              <div>
                We may share your personal information with trusted third-party service providers
                who assist us in delivering our services, such as loan processing, credit reporting,
                payment processing, data analytics, and customer support. These providers are
                obligated to maintain the confidentiality of your personal information and use it
                only to perform their functions. <br></br>
                In some cases, we may also share your information with third-party lenders to
                facilitate the loan application process. These lenders will be responsible for
                providing you with loan offers and managing the loan approval process.
              </div>
            </li>
            <li className="privacy-list-item">
              <h3>6. Financial Lender Partnerships </h3>
              <div>
                We only share aggregated, anonymized-level data collected to provide finance lenders
                insights CashClever makes sure to remain compliant to both Federal and State-level
                compliances <br></br>
                <ul className="ul">
                  <li className="privacy-list-item"> GLBA compliance</li>
                  <li className="privacy-list-item"> ECOA fair lending concerns</li>
                  <li className="privacy-list-item"> FCRA applicability</li>
                  <li className="privacy-list-item"> State Privacy Laws (CCPA, NY SHIELD, etc.)</li>
                  <li className="privacy-list-item"> Marketing Compliance (CAN-SPAM / TCPA)</li>
                </ul>
              </div>
            </li>
            <li className="privacy-list-item">
              <h3> 7. Security </h3>
              <div>
                We implement a variety of security measures to protect your personal information,
                including encryption, secure servers, and access control mechanisms. However, no
                method of data transmission or storage can be guaranteed 100% secure, and we cannot
                ensure or warrant the absolute security of your information. <br></br>
                We encourage you to use strong, unique passwords and to protect your login
                credentials. If you suspect that your account has been compromised, please notify us
                immediately.
              </div>
            </li>
            <li className="privacy-list-item">
              <h3> 8. Communication Preferences </h3>
              <div>
                You can control the communication preferences we use to contact you. By default, you
                may receive emails, text messages, and phone calls related to your loan application,
                account updates, and promotional offers. If you no longer wish to receive certain
                types of communications, you can opt out by:
                <ul className="ul">
                  <li className="privacy-list-item">
                    {' '}
                    Unsubscribing from emails using the 'unsubscribe' link in the email footer.
                  </li>
                  <li className="privacy-list-item">
                    {' '}
                    Replying 'STOP' to text messages to stop receiving further SMS communications.
                  </li>
                  <li className="privacy-list-item">
                    {' '}
                    Contacting customer service to update your preferences or opt out of specific
                    communications.
                  </li>
                </ul>
                Please note that you may still receive important account-related messages, such as
                loan status updates or security alerts, even if you opt out of marketing
                communications.
              </div>
            </li>
            <li className="privacy-list-item">
              <h3>9. Our Contact Information </h3>
              <div className="contact-info-description">
                If you have any questions, concerns, or requests regarding your personal information
                or this Privacy Policy, please contact us at:
              </div>
              <div>
                CashClever Corp.<br></br> 2 University Plaza, Suite 100 <br></br> Hackensack, NJ.
                07601
                <br></br> info@cashclever.net <br></br>
                1-646-780-9673
              </div>
            </li>
          </ol>
          <h3> Changes to This Privacy Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on this
            page with an updated 'Effective Date.' <br></br>We encourage you to review this policy
            periodically to stay informed about how we are protecting your information. By
            continuing to use the Platform after any changes to this Privacy Policy, you accept and
            agree to the updated terms.
          </p>

          <h3>Privacy Policy Laws Across Different States</h3>
          <ul>
            {Object.keys(PrivacyPolicyStateLaws).map((state) => {
              return (
                <li className="privacy-list-item">
                  <a
                    style={{ color: 'black' }}
                    target="_blank"
                    href={PrivacyPolicyStateLaws[state].href}
                    onClick={() => {
                      mixpanel.track('Privacy Policy', {
                        path: window?.location?.pathname,
                        state,
                      });
                    }}
                  >
                    {state}{' '}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <Footer currentPath={'/privacy_policy'} />
    </>
  );
};
